import "./styles/main.css";
import "./styles/main.scss";

import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";

import { configureStore } from "@reduxjs/toolkit";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import App from "App";
import { queryClient } from "libs/react-query/queryClient";
// import TagManager from "react-gtm-module";
import { Toaster } from "react-hot-toast";
import Modal from "react-modal";
import { Provider } from "react-redux";
import { RecoilRoot } from "recoil";
import createSagaMiddleware from "redux-saga";
import ReduxThunk from "redux-thunk";
import rootReducer, { rootSaga } from "store/redux/modules";
import reportWebVitals from "./reportWebVitals";

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: rootReducer,
  middleware: [ReduxThunk, sagaMiddleware],
});

sagaMiddleware.run(rootSaga);

// const tagManagerArgs = {
//   gtmId: "GTM-KFQVGFR",
// };

// TagManager.initialize(tagManagerArgs); // gtm에서 미리보기 테스트위해서는 stg 허용해줘야 합니다.

const domNode = document.getElementById("root");
if (!domNode) throw new Error("Failed to find the root element");
const root = createRoot(domNode);
// process.env.REACT_APP_API_BASE_URL === "https://prd.becon-api.com" && TagManager.initialize(tagManagerArgs);
const vh = window.innerHeight * 1;
document.documentElement.style.setProperty("--100vh", `${vh}px`);

root.render(
  <QueryClientProvider client={queryClient}>
    <ReactQueryDevtools />
    <Provider store={store}>
      <Router>
        <RecoilRoot>
          <App />
        </RecoilRoot>
      </Router>
      <Toaster
        reverseOrder={true}
        toastOptions={{
          duration: 2000,
          style: {
            marginTop: "50px",
            fontSize: "13px",
            fontWeight: "700",
            color: "#3d3d3d",
            wordBreak: "break-all",
          },
        }}
      />
    </Provider>
  </QueryClientProvider>,
);

Modal.setAppElement("#root");

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

export type AppDispatch = typeof store.dispatch;
